export const logrosData = [
  {
    titulo: "Actividad 1",
    dato: 3200,
    id: 1,
  },
  {
    titulo: "Actividad 2",
    dato: 4500,
    id: 2,
  },
  {
    titulo: "Actividad 3",
    dato: 2600,
    id: 3,
  },
  {
    titulo: "Actividad 4",
    dato: 2900,
    id: 4,
  },
];
